import script from "./StatsGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatsGrid.vue?vue&type=script&setup=true&lang=ts"

import "./StatsGrid.vue?vue&type=style&index=0&id=1a939392&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a939392"]])

export default __exports__